// Capture UTM parameters from the URL and store in sessionStorage for attribution.

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'kk_utm';

export function captureUTM() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    let found = false;

    UTM_PARAMS.forEach((key) => {
      const val = params.get(key);
      if (val) {
        utm[key] = val;
        found = true;
      }
    });

    if (found) {
      utm.landing_page = window.location.pathname;
      utm.timestamp = new Date().toISOString();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
    }
  } catch {
    // sessionStorage may be unavailable in some contexts
  }
}

export function getUTM() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
